export enum LoginState {
  LOGGED_IN,
  LOGGED_OUT,
}
